<evasys-notification></evasys-notification>

<evasys-loading-spinner></evasys-loading-spinner>

<evasys-modal-update-check></evasys-modal-update-check>

<evasys-app-shell>
	<router-outlet evasysScreen></router-outlet>
</evasys-app-shell>
